"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefab = exports.Prefab = void 0;
const uuid_1 = require("uuid");
const config_1 = require("./config");
const context_1 = __importDefault(require("./context"));
const evaluationSummaryAggregator_1 = require("./evaluationSummaryAggregator");
const loader_1 = __importDefault(require("./loader"));
const logger_1 = require("./logger");
const telemetryUploader_1 = __importDefault(require("./telemetryUploader"));
const loggerAggregator_1 = require("./loggerAggregator");
const version_1 = __importDefault(require("./version"));
class Prefab {
    constructor() {
        this._configs = {};
        this._pollCount = 0;
        this._pollStatus = { status: "not-started" };
        this._pollTimeoutId = undefined;
        this._instanceHash = (0, uuid_1.v4)();
        this.collectEvaluationSummaries = true;
        this.collectLoggerNames = false;
        this.clientNameString = "prefab-cloud-js";
        this.loaded = false;
        this.afterEvaluationCallback = (() => { });
        this._context = new context_1.default({});
    }
    init({ apiKey, context: providedContext, endpoints = undefined, apiEndpoint, timeout = undefined, afterEvaluationCallback = () => { }, collectEvaluationSummaries = true, collectLoggerNames = false, collectContextMode = "PERIODIC_EXAMPLE", clientNameString = "prefab-cloud-js", clientVersionString = version_1.default, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = providedContext !== null && providedContext !== void 0 ? providedContext : this.context;
            if (!context) {
                throw new Error("Context must be provided");
            }
            this._context = context;
            this.clientNameString = clientNameString;
            const clientNameAndVersionString = `${clientNameString}-${clientVersionString}`;
            this.loader = new loader_1.default({
                apiKey,
                context,
                endpoints,
                timeout,
                collectContextMode,
                clientVersion: clientNameAndVersionString,
            });
            this._telemetryUploader = new telemetryUploader_1.default({
                apiKey,
                apiEndpoint,
                timeout,
                clientVersion: clientNameAndVersionString,
            });
            this.collectEvaluationSummaries = collectEvaluationSummaries;
            if (collectEvaluationSummaries) {
                this.evalutionSummaryAggregator = new evaluationSummaryAggregator_1.EvaluationSummaryAggregator(this, 100000);
            }
            this.collectLoggerNames = collectLoggerNames;
            if (collectLoggerNames) {
                this.loggerAggregator = new loggerAggregator_1.LoggerAggregator(this, 100000);
            }
            if ((collectEvaluationSummaries || collectLoggerNames) && typeof window !== "undefined") {
                window.addEventListener("beforeunload", () => {
                    var _a, _b;
                    (_a = this.evalutionSummaryAggregator) === null || _a === void 0 ? void 0 : _a.sync();
                    (_b = this.loggerAggregator) === null || _b === void 0 ? void 0 : _b.sync();
                });
            }
            this.afterEvaluationCallback = afterEvaluationCallback;
            return this.load();
        });
    }
    get configs() {
        return this._configs;
    }
    get context() {
        return this._context;
    }
    get instanceHash() {
        return this._instanceHash;
    }
    get pollTimeoutId() {
        return this._pollTimeoutId;
    }
    get pollCount() {
        return this._pollCount;
    }
    get pollStatus() {
        return this._pollStatus;
    }
    get telemetryUploader() {
        return this._telemetryUploader;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loader || !this.context) {
                throw new Error("Prefab not initialized. Call init() first.");
            }
            // make sure we have the freshest context
            this.loader.context = this.context;
            return this.loader
                .load()
                .then((rawValues) => {
                this.setConfig(rawValues);
            })
                .finally(() => {
                if (this.pollStatus.status === "running") {
                    this._pollCount += 1;
                }
            });
        });
    }
    updateContext(context, skipLoad = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loader) {
                throw new Error("Prefab not initialized. Call init() first.");
            }
            this._context = context;
            if (skipLoad) {
                return Promise.resolve();
            }
            return this.load();
        });
    }
    poll({ frequencyInMs }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loader) {
                throw new Error("Prefab not initialized. Call init() first.");
            }
            this.stopPolling();
            this._pollStatus = { status: "pending" };
            return this.loader.load().finally(() => {
                this.doPolling({ frequencyInMs });
            });
        });
    }
    doPolling({ frequencyInMs }) {
        this._pollTimeoutId = setTimeout(() => {
            this.load().finally(() => {
                if (this.pollStatus.status === "running") {
                    this.doPolling({ frequencyInMs });
                }
            });
        }, frequencyInMs);
        this._pollStatus = {
            status: "running",
            frequencyInMs,
        };
    }
    stopPolling() {
        if (this.pollTimeoutId) {
            clearTimeout(this.pollTimeoutId);
            this._pollTimeoutId = undefined;
        }
        this._pollStatus = { status: "stopped" };
    }
    stopTelemetry() {
        var _a, _b;
        if (this.telemetryUploader) {
            (_a = this.evalutionSummaryAggregator) === null || _a === void 0 ? void 0 : _a.stop();
            (_b = this.loggerAggregator) === null || _b === void 0 ? void 0 : _b.stop();
        }
    }
    setConfig(rawValues) {
        this._configs = config_1.Config.digest(rawValues);
        this.loaded = true;
    }
    isEnabled(key) {
        return this.get(key) === true;
    }
    get(key) {
        if (!this.loaded) {
            if (!key.startsWith(logger_1.PREFIX)) {
                // eslint-disable-next-line no-console
                console.warn(`Prefab warning: The client has not finished loading data yet. Unable to look up actual value for key "${key}".`);
            }
            return undefined;
        }
        const config = this.configs[key];
        const value = config === null || config === void 0 ? void 0 : config.value;
        if (!key.startsWith(logger_1.PREFIX)) {
            if (this.collectEvaluationSummaries) {
                setTimeout(() => { var _a; return (_a = this.evalutionSummaryAggregator) === null || _a === void 0 ? void 0 : _a.record(config); });
            }
            setTimeout(() => this.afterEvaluationCallback(key, value, this.context));
        }
        return value;
    }
    getDuration(key) {
        const value = this.get(key);
        if (!value) {
            return undefined;
        }
        if (!Object.prototype.hasOwnProperty.call(value, "seconds") ||
            !Object.prototype.hasOwnProperty.call(value, "ms")) {
            throw new Error(`Value for key "${key}" is not a duration`);
        }
        return value;
    }
    shouldLog(args, async = true) {
        if (this.collectLoggerNames && (0, logger_1.isValidLogLevel)(args.desiredLevel)) {
            const record = () => { var _a; return (_a = this.loggerAggregator) === null || _a === void 0 ? void 0 : _a.record(args.loggerName, args.desiredLevel.toUpperCase()); };
            if (async) {
                setTimeout(record);
            }
            else {
                record();
            }
        }
        return (0, logger_1.shouldLog)(Object.assign(Object.assign({}, args), { get: this.get.bind(this) }));
    }
    isCollectingEvaluationSummaries() {
        return this.collectEvaluationSummaries;
    }
    isCollectingLoggerNames() {
        return this.collectLoggerNames;
    }
}
exports.Prefab = Prefab;
exports.prefab = new Prefab();
